import React, { Component } from 'react'
import _ from 'lodash'

import { apiConstants } from '../constants/apiConstants'
import {
  removeExtraSlashes,
  isCorpOrGoPayUser,
  getLocalizedContent,
} from '../helper'
import { Message } from '@paypalcorp/worldready-react'

class MoveOrCopy extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      moveOrCopyTo: '',
      optionHeader: getLocalizedContent('labels.tree.title'),
      prevMoveOrCopyTo: '',
      selectedOption: this.props.selectedOptionList,
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick, false)
  }

  handleClick = (event) => {
    const classList = event.target.classList.value

    if (
      !classList.includes('list__options') &&
      !classList.includes('moveorcopy')
    ) {
      this.props.fileOptionStatus('', false)
    }
  }

  fetchPrevItem = (path) => {
    const { selectedOption } = this.state
    const newPath = removeExtraSlashes(path).split('/')
    const optionHeader =
      path === '' || path === '/' ? '_fv_root' : newPath.pop()
    const prevPath =
      newPath.length === 0
        ? removeExtraSlashes(apiConstants.Root)
        : newPath.join('/')
    this.setState({
      optionHeader,
      moveOrCopyTo: '',
      prevMoveOrCopyTo: path === '_fv_root' || path === '' ? '' : prevPath,
    })
    this.props.fetchSearchDataForMoveCopy(
      path === '' || path === '/' ? '_fv_root' : path,
      selectedOption.replace('to', '').trim(),
    )
  }

  onMoveOrCopyToOptionsClick = (item) => {
    this.setState({ moveOrCopyTo: item })
  }

  fetchSearchDataForMoveCopy = (item) => {
    const { selectedOption } = this.state
    this.setState({
      optionHeader: item.fileName,
      moveOrCopyTo: '',
      prevMoveOrCopyTo: item.baseFolder,
    })
    const navigatePath = item.path

    this.props.fetchSearchDataForMoveCopy(
      navigatePath,
      selectedOption.replace('to', '').trim(),
    )
  }

  onMoveOrCopyHereClick = (item) => {
    if (item !== '') {
      this.setState({
        moveOrCopyTo: '',
        selectedOption: '',
      })
      this.props.pasteFile(item)
    }
  }

  moveToRootDirectory = () => {
    const homeDirectory = {
      fileType: 'folder',
      path: '/',
      baseFolder: '/',
    }
    this.setState({
      moveOrCopyTo: '',
      selectedOption: '',
    })
    this.props.pasteFile(homeDirectory)
  }

  checkMoveToHomeButtonVisibility = () => {
    const { user, itemToMove, itemToCopy } = this.props
    const { selectedOption } = this.state
    if (isCorpOrGoPayUser(user)) {
      const itempath =
        selectedOption.replace('to', '').trim() === 'Move'
          ? this.getBaseFolderOfMoveOrCopyItem(itemToMove)
          : this.getBaseFolderOfMoveOrCopyItem(itemToCopy)
      return itempath !== '/'
    }
    return false
  }

  getBaseFolderOfMoveOrCopyItem = (file) => {
    if (file.length > 0) {
      return file[0].baseFolder
    }
    return file.baseFolder
  }

  renderOptions = (moveOrCopyFolderDetails, moveOrCopyTo) => {
    const moveOrCopyToFolders = moveOrCopyFolderDetails.filter((item) => {
      return item.fileType === 'folder'
    })
    return moveOrCopyToFolders.length > 0 ? (
      <div className="list__options-item-content">
        {moveOrCopyToFolders.map((item, index) => {
          return (
            item.fileType === 'folder' && (
              <li
                className={`list__options list_options-list ${
                  item.path === moveOrCopyTo.path
                    ? 'list__option-list--selected'
                    : ''
                }`}
                key={index}
              >
                <a
                  className="ppvx_overflow-menu__list-item ppvx_text--md list__options list__options-item"
                  data-folder-name={item.fileName}
                  onClick={() => {
                    this.onMoveOrCopyToOptionsClick(item)
                  }}
                >
                  {item.fileName}
                </a>
                <div
                  className="list__options list__options-arrow"
                  onClick={() => this.fetchSearchDataForMoveCopy(item)}
                >
                  <span className="list__options ppvx_icon ppvx_icon--size_sm ppvx_icon-chevron-right" />
                </div>
              </li>
            )
          )
        })}
      </div>
    ) : (
      <div className="list__options-no-data">
        <Message id="labels.move.or.copy.no.folder" />
      </div>
    )
  }

  renderMoveOrCopyOptions = () => {
    const {
      moveOrCopyTo,
      optionHeader,
      prevMoveOrCopyTo,
      selectedOption,
    } = this.state
    const {
      moveOrCopyFolderDetails,
      folderListFetchInProgress,
      moveOrCopyFromButton,
    } = this.props
    const optype = selectedOption.replace(' to', '').toLowerCase()
    return (
      <ul
        className={`ppvx_overflow-menu__list list__options ppvx_overflow-menu__list--open ${
          moveOrCopyFromButton && 'list__option-from-button'
        }`}
        role="menu"
        id="myOverflowMenu"
      >
        <li className="list__options list__options-header">
          {prevMoveOrCopyTo !== '' && (
            <div onClick={() => this.fetchPrevItem(prevMoveOrCopyTo)}>
              <span className="list__options ppvx_icon ppvx_icon--size_sm ppvx_icon-chevron-left list__options-back-arrow" />
            </div>
          )}
          <div>
            {optionHeader === '_fv_root' ? (
              <Message id="labels.tree.title" />
            ) : (
              optionHeader
            )}
          </div>
        </li>

        <div>
          {folderListFetchInProgress ? (
            <div>
              <a className="list__options-item list__item--spin">
                <div style={{ marginLeft: '10px' }}>
                  <p className="ppvx_loading-spinner" role="alert">
                    <span className="ppvx_loading-spinner__screenreader" />
                  </p>
                </div>
              </a>
            </div>
          ) : (
            this.renderOptions(moveOrCopyFolderDetails, moveOrCopyTo)
          )}
        </div>
        <li className={`list__options list__options-footer`}>
          <div>
            {this.checkMoveToHomeButtonVisibility() && (
              <div
                className="list__option-move-home"
                data-pa-click={`${optype}`}
                onClick={() => {
                  this.moveToRootDirectory()
                }}
              >
                <Message
                  id={`${
                    optype === 'move'
                      ? 'labels.move.to.home'
                      : 'labels.copy.to.home'
                  }`}
                />
              </div>
            )}
          </div>
          <div
            className={`list__options  ${
              moveOrCopyTo !== '' ? 'list__options-footer--selected' : ''
            }`}
            data-pa-click={`${optype}`}
            onClick={() => {
              this.onMoveOrCopyHereClick(moveOrCopyTo)
            }}
          >
            <Message
              id={`${
                optype === 'move' ? 'labels.move.here' : 'labels.copy.here'
              }`}
            />
          </div>
        </li>
      </ul>
    )
  }

  render() {
    return this.renderMoveOrCopyOptions()
  }
}

export default MoveOrCopy
